import React from 'react';
import { Box, IconButton, TableCell, TableRow } from '@mui/material';
import QuantityHandle from './QuantityHandle';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { handleAmount } from '../../../shared/extra';
import { removeAnDenomination } from '../../../store/productDetails/action';

function DenominationTable() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);
  const dispatch = useDispatch();



  return (
    <>
      {DENOMINATION_STORE_DATA?.map((data) => {
        return (
          <TableRow
            key={`product-denomination-${data?.AMOUNT}`}
            sx={{
              '& td': {
                p: PRODUCTDETAILS?.rangeDenomination ? 0.5 : 1,
                fontFamily: "Be Vietnam Pro",
                color: "dark.main",
                fontSize: PRODUCTDETAILS?.rangeDenomination ?
                  { xs: "10.5px", sm: "9px", md: "11px", lg: "13px" } :
                  { xs: "11px", md: "15.5px" },
                fontWeight: 500,
                bgcolor: "denomination.main",
                whiteSpace: "nowrap",

              },

              '& td:first-of-type': {
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
                borderLeft: (theme) => `1px solid ${theme.palette.border.default}`,
                borderTop: (theme) => `1px solid ${theme.palette.border.default}`,
                borderBottom: (theme) => `1px solid ${theme.palette.border.default}`,

              },
              '& td:nth-of-type(2)': {
                borderTop: (theme) => `1px solid ${theme.palette.border.default}`,
                borderBottom: (theme) => `1px solid ${theme.palette.border.default}`,
              },
              '& td:nth-of-type(3)': {
                borderTop: (theme) => `1px solid ${theme.palette.border.default}`,
                borderBottom: (theme) => `1px solid ${theme.palette.border.default}`,
              },
              '& td:nth-of-type(4)': {
                borderTop: (theme) => `1px solid ${theme.palette.border.default}`,
                borderBottom: (theme) => `1px solid ${theme.palette.border.default}`,
              },
              '& td:last-of-type': {
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
                borderRight: (theme) => `1px solid ${theme.palette.border.default}`,
                borderTop: (theme) => `1px solid ${theme.palette.border.default}`,
                borderBottom: (theme) => `1px solid ${theme.palette.border.default}`,
              },
            }}
          >
            {/* Amount */}
            <TableCell align="center">
              {handleAmount(data?.AMOUNT)}
            </TableCell>

            {/* Quantity */}
            <TableCell align="center">
              <Box className="product__denomination_table_quantity">
                <QuantityHandle
                  denominationData={data}
                  rangeDenomination={PRODUCTDETAILS.rangeDenomination}
                />
              </Box>
            </TableCell>

            {/* Discount */}
            <TableCell align="center"
              sx={{

              }}>
              {data?.DISCOUNT}%
            </TableCell>


            {/* Total */}
            <TableCell align="center">
              {handleAmount(data.TOTAL)}
            </TableCell>

            {/* Action */}
            {PRODUCTDETAILS.rangeDenomination && (
              <TableCell align="center">
                <IconButton
                  onClick={() => removeDenoRow(data.AMOUNT)}
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            )}
          </TableRow>
        );
      })}
    </>
  );

  function removeDenoRow(amt) {
    dispatch(removeAnDenomination(amt));
  }
}

export default DenominationTable;